/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.authModule', [
  'angular-flatpickr',
  'angularMoment',
  'focus-if',
  'googleModule',
  'lodash',
  'ngCookies',
  'restangular',
  'ui.router',
  'ui.select',
  'bulbApp.ajaxModule',
  'bulbApp.busyModule',
  'bulbApp.configModule',
  'bulbApp.ageVerificationModule',
  'bulbApp.errorModule',
  'bulbApp.modalModule',
  'bulbApp.pushNotificationModule',
  'bulbApp.translateModule',
])

  .constant('AUTH', {
    ROLES: {
      ADMIN: 'ADMIN',
      USER: 'USER',
      REGISTERED_USER: 'REGISTERED_USER',
      TEST_USER: 'TEST_USER',
      SWITCHED_USER: 'SWITCHED_USER',
      ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
      FAMILY_MEMBER: 'FAMILY_MEMBER',
    },
    PERMISSIONS: {
      CREATE: 'CREATE',
      READ: 'READ',
      UPDATE: 'UPDATE',
      DELETE: 'DELETE',
      GRANT: 'GRANT',
    },
    ANONYMOUS_ACCOUNT: {
      USERNAME: 'Anonymous',
      FIRSTNAME: 'Anonymous',
      LASTNAME: 'User',
      DISPLAY_NAME: 'Anonymous User',
    },
    PRIVATE_ACCOUNT: {
      USERNAME: 'PrivateAccount',
      FIRSTNAME: 'Private',
      LASTNAME: 'Account',
      DISPLAY_NAME: 'Private Account',
    },
  })
  .run(['$rootScope', 'AUTH', run])
  .config(['$stateProvider', config]);

function run($rootScope, AUTH) {
  $rootScope.AUTH = AUTH;
}

function config($stateProvider) {
  $stateProvider
    .state('signIn', {
      parent: 'bulbView',
      url: '^/b/sign-in?mfa&redirected',
      params: {
        targetUrl: null,
        mfa: null,
        redirected: null,
        referrer: null,
        icev: false,
        exp: false,
      },
      resolve: {
        $title: ['$translate', ($translate) => $translate('sign_in')],
      },
      views: {
        // We define a different header and footer for the sign-in substate from the parent 'bulbview'.
        'header@root': {
          templateUrl: 'ajs/components/auth/bulb-header.html',
          controller: 'BulbHeaderController as bulbHeaderCtrl',
        },
        'content@root': {
          templateUrl: 'ajs/components/auth/signin.html',
          controller: 'SignInController as signInCtrl',
        },
      },
    })
    .state('icev', {
      parent: 'signIn',
      url: '^/b/sign-in/icev',
      params: {
        icev: true,
      },
    })
    .state('signInExp', {
      parent: 'signIn',
      url: '^/b/sign-in/exp',
      params: {
        exp: true,
      },
    })
    .state('signUp', {
      parent: 'bulbView',
      url: '^/b/sign-up?prepaidCode&orgToken&mode&uniqueName&&email&position&targetUrl&redirected',
      params: {
        connection: null,
        mode: { value: 'default', squash: true },
        subscribeMode: 'free',
        targetUrl: null,
        uniqueName: null,
        email: null,
        position: null,
        redirected: null,
        referrer: null,
        exp: null,
      },
      resolve: {
        isValidOrgToken: ['$stateParams', '$state', 'Restangular', function ($stateParams, $state, Restangular) {
          if ($stateParams.orgToken) {
            Restangular.one(`token/verifyToken/${$stateParams.orgToken}`).get().then((isValidOrgToken) => {
              if (!isValidOrgToken) {
                $state.go('error', { errorMessage: 'invalid_organization_token' }, { location: false });
              }
              return isValidOrgToken;
            }, (error) => {
              $state.go('error', { errorMessage: 'invalid_organization_token' }, { location: false });
            });
          }
        }],
        $title: ['$translate', ($translate) => $translate('sign_up')],
      },
      views: {
        // We define a different header and footer for the sign-in substate from the parent 'bulbview'.
        'header@root': {
          templateUrl: 'ajs/components/auth/bulb-header.html',
          controller: 'BulbHeaderController as bulbHeaderCtrl',
        },
        'content@root': {
          templateUrl: 'ajs/components/auth/signup.html',
          controller: 'SignUpController as signUpCtrl',
        },
      },
    })
    .state('signUpExp', {
      parent: 'signUp',
      url: '^/b/sign-up/exp',
      params: {
        exp: true,
      },
    })
    .state('trial60', {
      parent: 'signUp',
      url: '^/b/trybulb60?mode&uniqueName&email&position',
      params: {
        mode: 'default',
        subscribeMode: 'tryit60',
        uniqueName: null,
        email: null,
        position: null,
      },
      resolve: {
        $title: ['$translate', ($translate) => $translate('try_it_60')],
      },
    })
    .state('trial180', {
      parent: 'signUp',
      url: '^/b/trybulb180?mode&uniqueName&email&position',
      params: {
        mode: 'default',
        subscribeMode: 'tryit180',
        uniqueName: null,
        email: null,
        position: null,
      },
      resolve: {
        $title: ['$translate', ($translate) => $translate('try_it_180')],
      },
    })
    .state('resetPassword', {
      parent: 'bulbView',
      url: '^/b/resetpassword/newpassword?{token}&redirected',
      params: {
        token: {
          value: '',
          squash: true,
        },
        redirected: null,
      },
      resolve: {
        $title: ['$translate', ($translate) => $translate('reset_password_title')],
      },
      views: {
        bulbView: {
          templateUrl: 'ajs/components/auth/resetPassword.html',
          controller: 'ResetPasswordController as resetPasswordCtrl',
        },
      },
    })
    .state('buyBulb', {
      parent: 'signUp',
      url: '^/b/buybulb?mode&uniqueName&email&position',
      params: {
        connection: null,
        mode: 'default',
        subscribeMode: 'buy',
        targetUrl: null,
        uniqueName: null,
        email: null,
        position: null,
        referrer: null,
      },
      resolve: {
        $title: ['$translate', ($translate) => $translate('buy_bulb')],
      },
    })
    .state('trialEnding', {
      parent: 'bulbView',
      url: '^/b/trialEnding',
    })
    .state('successfulSignup', {
      parent: 'bulbView',
      url: '^/b/successful-signup?reloadUrl&setStorage',
      params: {
        reloadUrl: null,
        setStorage: null,
        referrer: null,
      },
      onEnter: ['$stateParams', '$window', 'AnalyticsService', ($stateParams, $window, AnalyticsService) => {
        // We need to force push an event to Google Tag Manager as this redirect moves too quickly
        // for the history listener to follow.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Pageview',
          pagePath: `${window.location.origin}/b/successful-signup`,
          pageTitle: 'Successful Signup',
        });
        AnalyticsService.push('event', 'sign_up');

        // Set 'isAuthorized' property in localstorage if reloadUrl is for like page.
        if ($stateParams.setStorage && $stateParams.referrer !== 'copy-template') {
          localStorage.setItem('isAuthorized', 'isAuthorized');
        }

        if ($stateParams.reloadUrl) {
          // eslint-disable-next-line no-param-reassign
          $window.location.href = $stateParams.reloadUrl;
        }
      }],
    })
    .state('mobileLaunch', {
      url: '^/b/mobileLaunch',
      controller: ['$state', '$window', 'Restangular', 'BulbAuthService',
        function mobileLaunchController($state, $window, Restangular, BulbAuthService) {

          if (!BulbAuthService.currentUser.isAuthenticated()) {
            // If the user isn't logged in, redirect to the sign-in page
            $state.go('signIn', { targetUrl: '/b/mobileLaunch' });

          } else {
            // If the user IS logged in, generate a one-use token and launch the mobile app
            Restangular.all('auth/token').post()
              .then((response) => {
                window.location.href = `bulbapp://?token=${response.token}`;
              });
          }
        }],
    });

}
